import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {DtoArticleSupplierList} from "./models/DtoArticleSupplierList";
import {DtoArticleSupplier} from "./models/DtoArticleSupplier";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";

@Component({
    selector: 'article-supplier',
    template: require('./article-supplier.component.html'),
    styles: [require('./article-supplier.component.css')]
})
@AutoUnsubscribe()

export class ArticleSupplierComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() allSuppliers: DtoArticleSupplierList[];
    @Input() chosenSuppliers: DtoArticleSupplier[];
    @Output() supplierSaved = new EventEmitter<DtoArticleSupplier>();
    @ViewChild('gridSupplier', {static: false}) gridSupplier: DynamicGridComponent;
    supplierColumnDefinition: ColumnDefinition[] = [
        {
            key: 'name',
            label: 'Leverancier',
            type: 'string',
            width: '*'
        },
        {
            key: 'customerNo',
            label: 'Klantnummer',
            type: 'string',
            width: '120px'
        },
        {
            key: 'phoneNumber',
            label: 'Telefoonnummer',
            type: 'number',
            width: '140px'
        }
    ];

    ngOnInit() {
        setTimeout(() => {
            let suppliersToShow: DtoArticleSupplierList[] = [];
            for (let i = 0; i < this.allSuppliers.length; i++) {
                if (!this.chosenSuppliers.find(x => x.supplierId == this.allSuppliers[i].id)) {
                    suppliersToShow.push(this.allSuppliers[i]);
                }
            }
            this.gridSupplier.showData(suppliersToShow);
        });

    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        if (this.gridSupplier.getSelectedId() > 0) {
            let supplier = this.allSuppliers.find(x => x.id == this.gridSupplier.getSelectedId());
            this.supplierSaved.emit({
                id: 0,
                supplierCustomerNo: supplier.customerNo,
                supplierName: supplier.name,
                supplierPhoneNumber: supplier.phoneNumber,
                supplierId: supplier.id,
                isPreferred: this.chosenSuppliers.length == 0
            });
            this.closeWindow(true);
        }
    }

    supplierRowdoubleClicked(event) {
        this.btnSaveClicked(null);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/article-supplier.component.ts